import React, { useState } from "react";
import { colors } from "../../../themes/Colors";
import BaseButtons from "../base-buttons/BaseButtons";
import SearchBar from "../search-bar/SearchBar";
import TextInputField from "../text-input-field/TextInputField";

const DropDownWithDisplay = ({
  selected,
  setSelected,
  data,
  title,
  tagline,
  opened,
  setOpened,
  makeDropDown,
  seriesDropDown,
  onSeriesClick,
  GetSeriesDataLinkedToMake,
  auth,
  setLoading,
  setRefresh,
  refesh,
  setMessage,
  setToastPop,
  make,
  setPopUpTitle,
  setSelectedMake,
  setSeries,
  isMobile,
}) => {
  const [open, setOpen] = useState(false);
  const [dropDownHover, setDropDownHover] = useState(null);
  const [hover, setHover] = useState(false);
  const [addMake, setAddMake] = useState(false);
  const [addSeries, setAddSeires] = useState(false);
  const [makeImage, setMakeImage] = useState("");
  const [makeName, setMakeName] = useState("");
  const [seriesImage, setSeriesImage] = useState("");
  const [seriesName, setSeriesName] = useState("");

  const AddNewMake = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/enatis/createNewMake",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            name: makeName.toLocaleUpperCase(),
            imageLink: makeImage,
            createdBy:
              auth.customerUserData.firstName +
              " " +
              auth.customerUserData.lastName,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setRefresh(refesh ? false : true);
        setLoading(false);
        setMessage(respnseData.success);
        setPopUpTitle("SUCCESS");
        setToastPop(true);
        setAddMake(false);
      } else {
        setPopUpTitle("FAILURE");
        setLoading(false);
        setMessage(respnseData.error);
        setToastPop(true);
      }
    } catch (err) {
      setPopUpTitle("FAILURE");
      setRefresh(refesh ? false : true);
      setLoading(false);
      setMessage(
        "Error occured contact support but make sure you have betwork first"
      );
      setToastPop(true);
    }
  };

  const AddNewSeries = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/enatis/createNewSeries",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            name: seriesName.toLocaleUpperCase(),
            make: make,
            imageLink: seriesImage,
            createdBy:
              auth.customerUserData.firstName +
              " " +
              auth.customerUserData.lastName,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setPopUpTitle("SUCCESS");
        setLoading(false);
        setMessage(respnseData.success);
        setToastPop(true);
        setAddSeires(false);
        GetSeriesDataLinkedToMake(make);
      } else {
        setPopUpTitle("FAILURE");
        setLoading(false);
        setMessage(respnseData.error);
        setToastPop(true);
      }
    } catch (err) {
      setPopUpTitle("FAILURE");
      setRefresh(refesh ? false : true);
      setLoading(false);
      setMessage(
        "Error occured contact support but make sure you have betwork first"
      );
      setToastPop(true);
    }
  };

  const ResetFields = () => {
    setMakeImage("");
    setMakeName("");
    setSeriesImage("");
    setSeriesName("");
  };
  return (
    <div
      style={{
        marginTop: 40,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
      }}
    >
      <div
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
        onClick={
          open
            ? () => {
                setOpen(opened === title ? true : false);
              }
            : () => {
                setOpen(true);
                setOpened(title);
              }
        }
        style={{
          height: 45,
          width: "82%",
          borderRadius: 8,
          position: "relative",
          backgroundColor: hover ? colors.greenLight : colors.greenDark,
          color: colors.white,
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
          transition: "all 0.3s",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: -25,
            left: 10,
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            color: "#000000",
          }}
        >
          <div>{title}</div>
          <div
            style={{
              fontSize: 14,
              fontWeight: "normal",
              marginLeft: 10,
            }}
          >
            {tagline}
          </div>
        </div>
        {selected ? <div>{selected}</div> : <div>Click here to select</div>}

        {makeDropDown && open && opened === title && !addMake ? (
          <div
            style={{
              position: "absolute",
              top: -295,
              width: "100%",
              backgroundColor: colors.secondaryGrey,
              zIndex: 201,
              borderRadius: 8,
              //   overflow: "hidden",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <BaseButtons
              label={isMobile ? "CANCEL" : "ADD MAKE"}
              backgroundColor={isMobile ? colors.orangeDark : colors.greenLight}
              width={"50%"}
              borderRadius={6}
              height={35}
              onClick={
                isMobile
                  ? () => {
                      setSelected("Click here to select");
                      setOpen(false);
                      setOpened(null);
                    }
                  : () => setAddMake(true)
              }
            />
            <div
              style={{
                width: "70%",
              }}
            >
              <SearchBar
                marginTop={-15}
                size={"87%"}
                width={"100%"}
                placeholder={"Type here to search make"}
              />
            </div>
          </div>
        ) : null}
        {seriesDropDown && open && opened === title && !addSeries ? (
          <div
            style={{
              position: "absolute",
              top: -295,
              width: "100%",
              backgroundColor: colors.secondaryGrey,
              zIndex: 220,
              borderRadius: 8,
              //   overflow: "hidden",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <BaseButtons
              label={isMobile ? "CANCEL" : "ADD MAKE"}
              backgroundColor={isMobile ? colors.orangeDark : colors.greenLight}
              width={"50%"}
              borderRadius={6}
              height={35}
              onClick={
                isMobile
                  ? () => {
                      setOpen(false);
                      setOpened(null);
                    }
                  : () => setAddSeires(true)
              }
            />
            <div
              style={{
                width: "70%",
              }}
            >
              <SearchBar
                marginTop={-15}
                size={"87%"}
                width={"100%"}
                placeholder={"Type here to search series"}
              />
            </div>
          </div>
        ) : null}

        <div
          style={{
            height: addMake ? 300 : 0,
            width: "100%",
            position: "absolute",

            backgroundColor: colors.greenDark,
            overflowY: "scroll",
            overflowX: "hidden",
            zIndex: 200,
            bottom: 0,
            transition: "height 0.3s",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 8,
          }}
        >
          <div
            style={{
              backgroundColor: colors.white,
              padding: 15,
              width: "90%",
              borderRadius: 8,
              height: "85%",
              display: "flex",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <TextInputField
                mini={true}
                labelTitle={"MAKE NAME"}
                value={makeName}
                onChange={(e) => setMakeName(e.target.value)}
              />
              <TextInputField
                mini={true}
                labelTitle={"IMAGE LINK"}
                value={makeImage}
                onChange={(e) => setMakeImage(e.target.value)}
              />
              <div
                style={{
                  width: "100%",
                  marginTop: 20,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <BaseButtons
                  label={"ADD MAKE"}
                  backgroundColor={colors.greenLight}
                  width={"50%"}
                  borderRadius={8}
                  onClick={() => AddNewMake()}
                />
                <div style={{ width: 15 }} />
                <BaseButtons
                  label={"CANCEL"}
                  backgroundColor={colors.orangeDark}
                  width={"50%"}
                  onClick={() => {
                    setAddMake(false);
                    ResetFields();
                  }}
                  borderRadius={8}
                />
              </div>
            </div>
            <div
              style={{
                color: "#000000",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ marginTop: 10, marginBottom: 10 }}>
                IMAGE DISPLAY
              </div>
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img alt="logo" src={makeImage} style={{ width: "100%" }} />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            height: addSeries ? 300 : 0,
            width: "100%",
            position: "absolute",

            backgroundColor: colors.greenDark,
            overflowY: "scroll",
            overflowX: "hidden",
            zIndex: 200,
            bottom: 0,
            transition: "height 0.3s",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 8,
            zIndex: 205,
          }}
        >
          <div
            style={{
              backgroundColor: colors.white,
              padding: 15,
              width: "90%",
              borderRadius: 8,
              height: "85%",
              display: "flex",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <TextInputField
                mini={true}
                labelTitle={"SERIES NAME"}
                value={seriesName}
                onChange={(e) => setSeriesName(e.target.value)}
              />
              <TextInputField
                mini={true}
                labelTitle={"IMAGE LINK"}
                value={seriesImage}
                onChange={(e) => setSeriesImage(e.target.value)}
              />
              <div
                style={{
                  width: "100%",
                  marginTop: 20,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <BaseButtons
                  label={"ADD SERIES"}
                  backgroundColor={colors.greenLight}
                  width={"50%"}
                  borderRadius={8}
                  onClick={() => AddNewSeries()}
                />
                <div style={{ width: 15 }} />
                <BaseButtons
                  label={"CANCEL"}
                  backgroundColor={colors.orangeDark}
                  width={"50%"}
                  onClick={() => {
                    setAddSeires(false);
                    ResetFields();
                  }}
                  borderRadius={8}
                />
              </div>
            </div>
            <div
              style={{
                color: "#000000",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ marginTop: 10, marginBottom: 10 }}>
                IMAGE DISPLAY
              </div>
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img alt="logo" src={seriesImage} style={{ width: "100%" }} />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            height: open && opened === title && !addMake ? 300 : 0,
            width: "100%",
            position: "absolute",

            backgroundColor: colors.white,
            overflowY: "scroll",
            overflowX: "hidden",
            zIndex: 200,
            bottom: 0,
            transition: "height 0.3s",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            borderRadius: 8,
          }}
        >
          {data.map((value, index) => {
            return (
              <div
                onClick={
                  makeDropDown
                    ? () => {
                        setSelected(value.name);
                        setOpen(false);
                        setOpened(null);
                        GetSeriesDataLinkedToMake(value.name);
                        setSelectedMake(value.name);
                        setSeries(null);
                      }
                    : () => {
                        setSelected(value.name);
                        setOpen(false);
                        setOpened(null);
                      }
                }
                key={index}
                style={{ width: "100%", color: colors.greenDark }}
              >
                <div
                  onMouseOver={() => setDropDownHover(index)}
                  onMouseOut={() => setDropDownHover(null)}
                  style={{
                    height: 30,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor:
                      dropDownHover === index
                        ? colors.greenLight
                        : colors.white,
                    color:
                      dropDownHover === index ? colors.white : colors.greenDark,
                    fontWeight: dropDownHover === index ? "bold" : "normal",
                  }}
                >
                  {value.name}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DropDownWithDisplay;
